module.exports = __webpack_public_path__ + "static/media/heroBG1080.080ca700.webp";